module.exports = "https://img.xiyuyouxi.com/saas/img/mine_menu2.c89bbac2.png";